import React from 'react';
import { Star, Quote, Sparkles } from 'lucide-react';

const TestimonialsSection = () => {
  const reviews = [
    {
      id: 1,
      quote: "My wedding Kanjivaram from Vedhyas was nothing short of a masterpiece. The pure mulberry silk drape and rich gold zari weave made me feel like royalty on my big day.",
      author: "Ananya Deshmukh",
      role: "Bridal Patron, Mumbai",
      rating: 5,
    },
    {
      id: 2,
      quote: "The antique temple jewelry set paired impeccably with my heritage silk saree. The intricate Kemp stone setting and antique gold finish received endless compliments.",
      author: "Meera Ramakrishnan",
      role: "Patron, Chennai",
      rating: 5,
    },
    {
      id: 3,
      quote: "Ordering high-end handloom sarees online can be daunting, but Vedhyas surpassed all expectations. Exceptional craftsmanship, authentic pure silk, and royal packaging.",
      author: "Dr. Kavita Rao",
      role: "Collector & Patron, Bengaluru",
      rating: 5,
    },
  ];

  return (
    <section className="mb-16 sm:mb-20">
      {/* Section Header */}
      <div className="text-center max-w-lg mx-auto mb-10">
        <div className="inline-flex items-center space-x-1.5 mb-1.5">
          <Sparkles className="w-3.5 h-3.5 text-[#4A0E17]" />
          <span className="text-[10px] font-serif font-bold tracking-[0.25em] text-[#4A0E17] uppercase">
            Patron Stories
          </span>
        </div>
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-[#4A0E17]">
          Cherished By Brides & Connoisseurs
        </h2>
      </div>

      {/* Testimonials Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.map((rev) => (
          <div
            key={rev.id}
            className="bg-[#FDFBF7] rounded-3xl p-6 sm:p-7 border border-[#E8DFC8] shadow-sm flex flex-col justify-between relative overflow-hidden group hover:border-[#4A0E17]/40 hover:shadow-md transition-all duration-300"
          >
            {/* Background Decorative Quote Mark */}
            <Quote className="w-12 h-12 text-[#F4EFE6] absolute top-4 right-4 z-0 group-hover:text-[#4A0E17]/10 transition-colors" />
            
            <div className="relative z-10">
              {/* Star Rating */}
              <div className="flex space-x-1 mb-4">
                {[...Array(rev.rating)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 text-[#4A0E17] fill-current" />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-xs text-[#544842] font-light leading-relaxed italic">
                "{rev.quote}"
              </p>
            </div>

            {/* Author Footer */}
            <div className="mt-6 pt-4 border-t border-[#E8DFC8]/60 relative z-10">
              <h4 className="text-xs font-serif font-bold text-[#4A0E17]">{rev.author}</h4>
              <p className="text-[10px] text-[#7A6B5D] font-serif font-medium">{rev.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;